import { LwButton, Toolbox } from 'redesign';
import { IconApproved, IconCancel } from 'assets/img';
import { useTranslation } from 'react-i18next';
import type { SettingsEditThemeToolboxProps } from './setting-edit-theme-toolbox.types';

export const SettingsEditThemeToolbox = (props: SettingsEditThemeToolboxProps) => {
  const { t } = useTranslation(['web-common']);

  return (
    <Toolbox underline>
      <LwButton onClick={props.handleSubmit} iconColorMode="stroke" startIcon={<IconApproved />}>
        {t('buttons.confirm', { ns: 'web-common' })}
      </LwButton>
      <LwButton
        onClick={props.handleCancel}
        iconColorMode="fill"
        color="secondary"
        startIcon={<IconCancel />}
      >
        {t('buttons.cancel', { ns: 'web-common' })}
      </LwButton>
    </Toolbox>
  );
};
